export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["ACTIVE"] = "active";
    CustomerStatus["INACTIVE"] = "inactive";
    CustomerStatus["SUSPENDED"] = "suspended";
    CustomerStatus["DELETED"] = "deleted";
    CustomerStatus["TRIAL"] = "trial";
})(CustomerStatus || (CustomerStatus = {}));
//# sourceMappingURL=constants.js.map